export const displayName = (
  firstName: string | null | undefined,
  lastName: string | null | undefined,
): string => {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }
  return lastName || firstName || '';
};
